module.exports = __webpack_public_path__ + "img/162.0b4e0a4a.jpg";